module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i-box', {
    attrs: {
      "selected": _vm.selected
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "arrow arrow-left",
    on: {
      "click": _vm.onClickPrevious
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "arrow arrow-right",
    on: {
      "click": _vm.onClickNext
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "unit-title"
  }, [_c('span', {
    staticClass: "label pull-right",
    class: _vm.unitClass
  }, [_vm._v(_vm._s(_vm.unit))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.period))])])]), _vm._v(" "), (_vm.processStats.length) ? _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('h1', {
    staticClass: "no-margins"
  }, [_vm._v(_vm._s(Math.round(_vm.received).toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "stat-percent font-bold",
    class: {
      'text-success': _vm.growth > 0,
        'text-danger': _vm.growth < 0,
        'text-muted': _vm.growth === 0,
    }
  }, [_vm._v("\n      " + _vm._s(Math.round(_vm.growth)) + "%\n      "), _c('i', {
    staticClass: "fa",
    class: {
      'fa-level-up': _vm.growth > 0,
        'fa-level-down': _vm.growth < 0,
        'fa-minus': _vm.growth === 0,
    }
  })]), _vm._v(" "), (_vm.showBreakdown) ? _c('div', {
    staticClass: "voice-breakdown"
  }, [(_vm.approved !== null) ? _c('span', {
    staticClass: "breakdown-badge breakdown-badge--approved"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" " + _vm._s(_vm.approved) + " approved\n      ")]) : _vm._e(), _vm._v(" "), (_vm.flagged !== null) ? _c('span', {
    staticClass: "breakdown-badge breakdown-badge--flagged"
  }, [_c('i', {
    staticClass: "fa fa-flag"
  }), _vm._v(" " + _vm._s(_vm.flagged) + " flagged\n      ")]) : _vm._e(), _vm._v(" "), (_vm.pending !== null) ? _c('span', {
    staticClass: "breakdown-badge breakdown-badge--pending"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.pending) + " pending\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('small', {
    staticClass: "description-text"
  }, [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('div', {
    staticClass: "sparkline"
  }, [_c('trend', {
    attrs: {
      "data": _vm.processStats,
      "gradient": _vm.gradient,
      "height": 40,
      "auto-draw": "",
      "smooth": ""
    }
  })], 1)]) : _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._t("content-loader", [_c('div', {
    staticClass: "voice-skeleton"
  }, [_c('div', {
    staticClass: "skeleton-count"
  }), _vm._v(" "), _c('div', {
    staticClass: "skeleton-line skeleton-line--short"
  }), _vm._v(" "), _c('div', {
    staticClass: "skeleton-line skeleton-line--long"
  }), _vm._v(" "), _c('div', {
    staticClass: "skeleton-chart"
  })])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-446db288","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/voiceIntelligence/VoiceAnalyticsUnitBlock.vue
// module id = 3254
// module chunks = 3